const FEATURED_BANNERS_ROUTES = {
  path: 'featured-banners',
  component: () =>
    import('@/pages/FeaturedBanners/FeaturedBannersPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'featured-banners.index',
      component: () =>
        import('@/pages/FeaturedBanners/FeaturedBannersPage.vue'),
    },
    {
      path: 'create',
      name: 'featured-banners.create',
      component: () =>
        import('@/pages/FeaturedBanners/FeaturedBannersFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'featured-banners.edit',
      component: () =>
        import('@/pages/FeaturedBanners/FeaturedBannersFormPage.vue'),
    },
  ],
};

export default FEATURED_BANNERS_ROUTES;
